"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { ArrowTopRightOnSquareIcon, ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
import WavesIcon from "@/components/common/icons/WavesIcon";
interface WaveCreatorPreviewItemProps {
  readonly wave: ApiWave;
  readonly onSelect?: ((wave: ApiWave, href: string, event: React.MouseEvent) => void) | undefined;
}
export const WaveCreatorPreviewItem: React.FC<WaveCreatorPreviewItemProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    onSelect
  } = t0;
  const isDirectMessage = wave.chat.scope.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== isDirectMessage || $[1] !== wave.id) {
    t1 = getWaveRoute({
      waveId: wave.id,
      isDirectMessage,
      isApp: false
    });
    $[0] = isDirectMessage;
    $[1] = wave.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const waveHref = t1;
  let t2;
  if ($[3] !== wave.picture) {
    t2 = wave.picture ? getScaledImageUri(wave.picture, ImageScale.W_AUTO_H_50) : null;
    $[3] = wave.picture;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const imageSrc = t2;
  const FallbackIcon = isDirectMessage ? ChatBubbleLeftRightIcon : WavesIcon;
  let t3;
  if ($[5] !== onSelect || $[6] !== wave || $[7] !== waveHref) {
    t3 = event => {
      if (!onSelect) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      onSelect(wave, waveHref, event);
    };
    $[5] = onSelect;
    $[6] = wave;
    $[7] = waveHref;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== FallbackIcon || $[10] !== imageSrc || $[11] !== wave.name) {
    t4 = <div className="tw-flex tw-h-10 tw-w-10 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10">{imageSrc ? <Image src={imageSrc} alt={wave.name ? `Wave ${wave.name}` : "Wave picture"} width={40} height={40} className="tw-h-full tw-w-full tw-object-cover" /> : <FallbackIcon className="tw-h-4 tw-w-4 tw-text-iron-300" />}</div>;
    $[9] = FallbackIcon;
    $[10] = imageSrc;
    $[11] = wave.name;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== wave.name) {
    t5 = <div className="tw-truncate tw-text-sm tw-font-semibold tw-text-iron-100">{wave.name}</div>;
    $[13] = wave.name;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== wave.metrics.latest_drop_timestamp) {
    t6 = wave.metrics.latest_drop_timestamp ? <><span>Last drop: </span><span className="tw-text-iron-300">{getTimeAgoShort(wave.metrics.latest_drop_timestamp)}</span></> : "No drops yet";
    $[15] = wave.metrics.latest_drop_timestamp;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <div className="tw-truncate tw-text-xs tw-text-iron-500">{t6}</div>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <div className="tw-min-w-0 tw-flex-1">{t5}{t7}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ArrowTopRightOnSquareIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-500 desktop-hover:group-hover:tw-text-iron-300" />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t8 || $[26] !== waveHref) {
    t10 = <Link href={waveHref} prefetch={false} onClick={t3} className="tw-group tw-flex tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-iron-800/70 tw-bg-iron-950/60 tw-px-4 tw-py-3 tw-no-underline tw-transition tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-400/60 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900/60">{t4}{t8}{t9}</Link>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t8;
    $[26] = waveHref;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};